<template>
  <el-row type="flex" justify="center" class="location-management">
    <el-col :span="9">
      <el-alert
        v-if="unhandledErrorMessage !== ''"
        :title="unhandledErrorMessage"
      ></el-alert>
      <el-row type="flex" justify="end" class="action-toolbar-row">
        <el-col :span="9">
          <er-input
            inputType="search"
            size="mini"
            v-model="searchLocation"
            suffix-icon="el-icon-search"
            :placeholder="$t('Comn_location')"
          ></er-input>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" class="table-container">
        <er-data-tables
          class="locations-table"
          uniqueId="location-table"
          :key="$i18n.locale"
          :table-data="locations"
          :el-table-props="table_props"
          :columns="tableColumns"
          :actionColumn="false"
          type="white-header-table"
        >
          <template v-slot:actions="{ row }">
            <el-popover
              popper-class="location_management"
              placement="bottom"
              :title="$t('Comn_edit')"
              width="200"
              v-model="row.data.visible"
              @show="handlePopperEvent(row.data)"
            >
              <er-input
                size="small"
                class="edit-input-location"
                :ref="`inputLocation${row.data._id}`"
                v-model="location_name"
              ></er-input>

              <el-row type="flex" justify="end" style="margin-top:15px;">
                <er-button
                  btnType="save"
                  :showLabel="true"
                  :showIcon="true"
                  size="mini"
                  :disabled="isReadOnly"
                  :loading="loading"
                  @keyup.enter.native="handleUpdateLocationName(row.data._id)"
                  @click="handleUpdateLocationName(row.data._id)"
                ></er-button>
                <er-button
                  btnType="cancel"
                  size="mini"
                  :showLabel="true"
                  :disabled="isReadOnly"
                  @click="handleClosePopper(row.data)"
                  >{{ $t("Comn_cancel") }}</er-button
                >
              </el-row>
              <er-button
                :showLabel="true"
                :showIcon="true"
                type="text"
                size="mini"
                slot="reference"
                btnType="edit"
                :disabled="isReadOnly"
              ></er-button>
            </el-popover>
            <el-divider direction="vertical"></el-divider>
            <er-button
              :showLabel="true"
              :showIcon="true"
              type="text"
              size="mini"
              btnType="delete"
              :disabled="isReadOnly"
              @click="handleDeleteClick(row.data)"
            ></er-button>
          </template>
        </er-data-tables>
      </el-row>
    </el-col>
    <er-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :title="$t('Comn_no_deletelocations')"
      custom-class="location_dialog"
    >
      <el-timeline>
        <el-timeline-item v-for="info in infoLangKeys" :key="info">
          <i18n :path="info" tag="span">
            <template v-slot:location>
              <strong class="captalize">{{ location_name }}</strong>
            </template>
          </i18n>
        </el-timeline-item>
      </el-timeline>
      <span class="el-row el-row--flex">
        <el-checkbox v-model="checked"></el-checkbox>
        <p class="checkbox-content">{{ $t("agree_delete_location_msg") }}</p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-row>
          <er-button
            :disabled="!checked || isReadOnly"
            btnType="confirm"
            size="mini"
            @click="handleRemoveLocation"
            >{{ $t("Comn_confirm") }}</er-button
          >
        </el-row>
      </span>
    </er-dialog>
  </el-row>
</template>

<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      checked: false,
      location_name: "",
      visible: false,
      selectedLocationObj: {},
      table_props: {
        border: false,
        size: "mini",
        defaultSort: {
          prop: "name",
          order: "ascending"
        }
      },
      disabled: true,
      searchLocation: "",
      infoLangKeys: [
        "all_schedules_delete_in_location_msg",
        "all_devices_delete_in_location_msg",
        "all_ponds_delete_in_location_msg",
        "delete_location_msg"
      ]
    };
  },
  computed: {
    ...mapGetters("user", {
      isReadOnly: "isReadOnly"
    }),
    locations() {
      return this.getLocations.filter(
        location =>
          this.seachLocation !== "" &&
          location.name
            .toLowerCase()
            .includes(this.searchLocation.toLowerCase())
      );
    },
    getLocations: {
      get() {
        const locations = [];
        this.$store.getters["user/getUserLocations"].forEach(
          ({ name, _id }) => {
            locations.push({ _id, name, visible: false });
          }
        );
        return locations;
      },
      set(value) {
        this.$store.dispatch("user/fetchAllUserLocations");
      }
    },
    tableColumns() {
      return {
        location: {
          prop: "name",
          label: this.$t("Comn_location"),
          minWidth: 200,
          sortable: true,
          sortMethod: this.$commonUtils.naturalSort("name")
        },
        actions: {
          prop: "actions",
          label: this.$t("Comn_actions"),
          minWidth: 100
        }
      };
    }
  },
  methods: {
    ...mapActions("user", {
      updateCurrUserLocation: "updateCurrUserLocation"
    }),
    handleRemoveLocation: async function() {
      // const loading = this.$loading({ fullscreen: true });
      try {
        await this.$store.dispatch(
          "user/deleteLocation",
          this.selectedLocationObj._id
        );
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("Comn_location_del_success"),
          duration: 5000,
          type: "success"
        });
      } catch (err) {
        this.errorMessages(err, true);
        this.$notify({
          title: this.$t("failed"),
          message: this.$t("failed_to_complete_the_action_for_resource", {
            action: this.$t("Comn_confirm"),
            resource_name: this.location_name
          }),
          duration: 5000,
          type: "error"
        });
      } finally {
        // loading.close();
        this.dialogVisible = false;
      }
    },
    handleUpdateLocationName: async function(locationId) {
      this.loading = true;
      this.unhandledErrorMessage = "";
      try {
        this.isHighPriorityUsersRestricted();
        const currLocation = await this.$store.dispatch(
          "user/updateLocationName",
          {
            locationId,
            location_name: this.location_name
          }
        );
        await this.updateCurrUserLocation(currLocation);
        this.location_name = "";
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("Comn_location_upd_success"),
          duration: 5000,
          type: "success"
        });
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    handleClosePopper: function(location) {
      location.visible = false;
      this.location_name = "";
    },
    handlePopperEvent: function(location) {
      try {
        this.isHighPriorityUsersRestricted();
        this.location_name = location.name;
        this.$nextTick(() => {
          this.$refs[`inputLocation${location._id}`].select();
          console.log(this.$refs[`inputLocation${location._id}`].focused);
        });
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleDeleteClick(location) {
      try {
        this.isHighPriorityUsersRestricted();
        this.location_name = location.name;
        this.selectedLocationObj = location;
        this.dialogVisible = true;
      } catch (err) {
        this.errorMessages(err, true);
      }
    }
  }
};
</script>

<style lang="scss">
.edit-input-location {
  .el-input__inner {
    text-transform: capitalize;
  }
}
.location-management {
  padding-top: 10px;
  padding-bottom: 10px;
  table {
    width: 520px !important;
  }
  .cell {
    text-transform: capitalize;
    letter-spacing: 0.5px;
  }
  .action-toolbar-row {
    margin-bottom: 10px;
    .el-input--mini .el-input__inner {
      font-size: 14px;
    }
  }
}

.location_dialog {
  background: #fcfcfc;
  border-radius: 10px;
  .el-dialog__header {
    color: white;
    background-color: #44a1ff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .el-dialog__headerbtn {
    .el-dialog__close {
      color: white;
    }
  }
  .captalize {
    text-transform: capitalize;
  }
  .el-timeline-item__content {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
  }
  .checkbox-content {
    margin-left: 10px;
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
  }
}
.location_management {
  .el-popover__title {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );

    color: #0a2463;
    line-height: 1;
    margin-bottom: 12px;
  }

  .er-button.el-button--mini:not(.is-circle) {
    padding: 7px 12px;
    font-size: 13px;
  }
}
</style>
